import {
  axios
} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findAgentInformation({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`agentInformation/findAgentInformation`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`agentInformation/findById`, {
          params
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findById({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`agentInformation/findById`, {
          params
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteById({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`agentInformation/deleteById`,{
        params
      })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
},
  saveAgentInformation({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`agentInformation/saveAgentInformation`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findByCompanyName({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`agentInformation/findByCompanyName`, {
          params
        })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
